import React from 'react';
import { motion } from 'framer-motion';

const LoadingSpinner = ({ size = 'md', color = 'primary', fullScreen = false }) => {
  // Size configs — each defines the container dimension and dot size
  // xs/button: small enough to sit inline inside a button
  const sizeConfig = {
    xs:    { container: 16, dot: 5,  travel: 5  },
    sm:    { container: 20, dot: 6,  travel: 6  },
    md:    { container: 40, dot: 12, travel: 12 },
    lg:    { container: 60, dot: 18, travel: 18 },
    xl:    { container: 80, dot: 24, travel: 24 },
    xxl:   { container: 100, dot: 30, travel: 30 },
  };

  const cfg = sizeConfig[size] || sizeConfig.md;
  const { container, dot, travel } = cfg;

  const wrapperStyle = fullScreen
    ? {
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(17, 24, 39, 0.8)',
        zIndex: 50,
      }
    : {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: container,
        height: container,
        flexShrink: 0,
      };

  const cycleDuration = 1.1;
  const transition = {
    duration: cycleDuration,
    repeat: Infinity,
    ease: 'easeInOut',
  };

  return (
    <div style={wrapperStyle}>
      <motion.div
        style={{
          position: 'relative',
          width: container,
          height: container,
          transformOrigin: 'center',
        }}
        animate={{ rotate: 360 }}
        transition={{ duration: cycleDuration * 3, repeat: Infinity, ease: 'linear' }}
      >
        <motion.div
          style={{
            width: dot,
            height: dot,
            borderRadius: '50%',
            position: 'absolute',
            top: 0, bottom: 0, left: 0, right: 0,
            margin: 'auto',
            backgroundColor: '#FFC107',
          }}
          animate={{ x: [0, travel, 0], y: [0, travel * 0.75, 0], scale: [1, 0.5, 1] }}
          transition={transition}
        />
        <motion.div
          style={{
            width: dot,
            height: dot,
            borderRadius: '50%',
            position: 'absolute',
            top: 0, bottom: 0, left: 0, right: 0,
            margin: 'auto',
            backgroundColor: '#3B5BA5',
          }}
          animate={{ x: [0, -travel, 0], y: [0, travel * 0.75, 0], scale: [1, 0.5, 1] }}
          transition={transition}
        />
        <motion.div
          style={{
            width: dot,
            height: dot,
            borderRadius: '50%',
            position: 'absolute',
            top: 0, bottom: 0, left: 0, right: 0,
            margin: 'auto',
            backgroundColor: '#E63946',
          }}
          animate={{ y: [0, -travel, 0], scale: [1, 0.5, 1] }}
          transition={transition}
        />
      </motion.div>

      {fullScreen && (
        <div style={{
          marginTop: '20px',
          color: 'white',
          fontWeight: 500,
          fontSize: '18px',
          letterSpacing: '0.1em',
        }}>
          LOADING
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;
